<template>
  <header class="mobile-header">
    <div class="header-bar">
      <div class="header-inner">
        <router-link to="/" class="logo">
          <img :src="logoImg" alt="김포 칸타빌 에디션" class="logo-img" />
        </router-link>
      </div>
    </div>
  </header>
</template>

<script>
import logoImg from '@/assets/logo/logo.png'

export default {
  name: 'MobileHeader',
  data() {
    return {
      logoImg
    }
  }
}
</script>

<style scoped>
.mobile-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

.header-bar {
  background: var(--primary, #3f3536);
  transition: background 0.3s ease;
}

.header-inner {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo {
  display: flex;
  align-items: center;
  text-decoration: none;
}

.logo-img {
  height: 36px;
  width: auto;
  display: block;
  /* 로고를 흰색으로 매핑 (어두운 헤더 배경 대응) */
  filter: brightness(0) invert(1);
}
</style>
